"use client";
import React, { useState } from 'react';
import Header from '../Header';
import Sidebar from '../Sidebar';
import PaySlips from './PaySlips';

const PaySlipsDashboard = () => {
 const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
 
   const toggleSidebar = () => {
     setSidebarCollapsed(!sidebarCollapsed);
   };
 
   return (
     <>
       <link
         rel="stylesheet"
         href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&family=Lato:wght@400;600;700&family=Noto+Sans:wght@400;700&family=Inter:wght@600;700&family=Poppins:wght@400;500;600;700&display=swap"
       />
       <div className=" bg-sky-50">

             <div className="box-border px-9 py-5 m-0 max-sm:p-5">
               {/* <div className="box-border flex justify-between items-center p-0 m-0 mb-8 max-sm:flex-col max-sm:gap-4 max-sm:items-start">
                 <h1 className="box-border p-0 m-0 text-3xl font-bold text-gray-800 max-sm:text-2xl">
                   Dashboard
                 </h1>
                 
               </div> */}
 
                <PaySlips/>
              
             </div>

       </div>
     </>
  );
};

export default PaySlipsDashboard;
